import { http } from "./http";
import { GET_PHARMACY_LICENSES_BY_PHARMACY_ID_URL } from "./URL";
import { PharmacyLicense } from "../utils/rxOrderGating/types";

/**
 * CS-2073 — Fetch pharmacy_licenses rows for a manufacturer (param name pharmacyId for API compat).
 */
export const getPharmacyLicensesByPharmacyId = async (
  pharmacyId: number
): Promise<PharmacyLicense[]> => {
  const params = new URLSearchParams({ pharmacyId: String(pharmacyId) });
  const response = await http.get(
    `${GET_PHARMACY_LICENSES_BY_PHARMACY_ID_URL}?${params.toString()}`,
    { headers: { "x-skip-loader": "true" } }
  );
  const rows = response?.data?.data;
  return Array.isArray(rows) ? (rows as PharmacyLicense[]) : [];
};
